/* React */
import React from "react";
/* Routing */
import { Routes, Route } from 'react-router-dom';
/* Common */
import Layout from "./components/common/Layout";
/* Pages */
import Home from './pages/Home';
import ObituaryDetail from './pages/ObituaryDetail';
import CondolencesList from './pages/CondolencesList';
import Missing from "./pages/Missing";
import Unauthorized from './pages/Unauthorized';

export default function App() {
    return (
        <Routes>
            {/* Public routes */}
            <Route path="" element={<Layout />}>
                <Route path="unauthorized" element={<Unauthorized />} />
                <Route exact path="listes-avis-deces/:agencyId/:page" element={<Home />} />
                <Route exact path="api/v1/listes-avis-deces/:agencyId/:page" element={<Home />} />
                <Route path="avis-deces/:agencyId/1/:id" element={<ObituaryDetail />} />
                <Route path="api/v1/avis-deces/:agencyId/1/:id" element={<ObituaryDetail />} />
                <Route path="condolences/:agencyId/1/:id" element={<CondolencesList />} />
                <Route path="api/v1/condolences/:agencyId/1/:id" element={<CondolencesList />} />

                {/* Catch all*/}
                <Route path="*" element={<Missing />} />
            </Route>
        </Routes>
    )
}
